import { PageHero, CTABanner } from "../components/Shared";
import ServicesSection from "../sections/ServicesSection";
import { IMAGES } from "../data/site";

const ServicesPage = () => (
  <main data-testid="services-page">
    <PageHero
      eyebrow="Our Services"
      title="Commercial print solutions, end to end."
      description="Offset printing, brochures, catalogues, wobblers, danglers and streamers — produced with meticulous care on advanced Heidelberg presses."
      image={IMAGES.brochure}
    />
    <ServicesSection />
    <CTABanner
      title="Have a print requirement in mind?"
      text="Share the details and receive a considered, transparent quote from our team."
    />
  </main>
);

export default ServicesPage;
